export const BASE_URL = 'https://gold-finance-backend.onrender.com/';
// export const BASE_URL = 'http://localhost:5000/';
export const TOKEN = 'token';
